import React, { useState, useEffect } from "react";
import {
    Input, Button, Card, CardBody, CardHeader, Col, Collapse, Container, Row, FormGroup, Label, FormFeedback, Spinner, TabContent, TabPane, Nav, NavItem, NavLink,
} from "reactstrap";
import { TableStriped } from "../../../components/tables/TableStriped";
import "react-morphing-modal/dist/ReactMorphingModal.css";
import { useCreateWSProcess } from '../../../hooks/worksheetsanitary/useCreateWSProcess';
import Select from "react-select";
import { ButtonGoBack } from "../../../constant";
import { useDetectedActivity } from "../../../hooks/exams/useDetectedActivity";
import { useHistory } from 'react-router-dom';
import { FormUpdateWS } from "../../../components/worksheetsanitary/FormUpdateWS";
import { ModalCreateUWSProcess } from "../../../components/worksheetsanitary/ModalCreateUWSProcess";


export const CreateWSProcess = () => {


    const {
        idwsconfigProcess, idwsconfig_a, catwsprocess, id_process_config, validaciones,
        method,
        handleInputChange, handleSearchWSS, loading,
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        datadeterminations, handleUpdateValues, handleSelectValues, formValues,
        navigateNewProcessWS, formValuesUpdate, dataDatacatwsprocessSearch, handleSelectValuesNew,
        id_exam, idwsconfig, order_element, name, comment_dilutions_colonies, is_lm, is_ec,
        catwselement, id_elements_config, dataDatacatwselementSearch,
        handleSearchWSSElements, handleUpdateElements, saveUpdateElements, handleDeleteElements,
        saveDeleteElements, validarFormElements, handleCreateElements, saveCreateElements,
        formValuesElements, handleInputChangeElements, handleUpdateValuesElements, handleSelectValuesElements,
        validacionesElements, catwsdilutions,

             //diluciones
             handleSearchWSSDilutions,handleUpdateDilutions,saveUpdateDilutions,handleDeleteDilutions,
             saveDeleteDilutions,validarFormDilutions,handleCreateDilutions,saveCreateDilutions,
             formValuesDilutions, handleInputChangeDilutions, handleUpdateValuesDilutions, handleSelectValuesDilutions,
             validacionesDilutions,



    } = useCreateWSProcess(true);

    let _type = 0

    const { innerHeight: height } = window;

    useDetectedActivity(60000, 10000);
    const history = useHistory();
    const [activeTab, setActiveTab] = useState('1');

    const changeTabGeneral = (tab) => {
        setActiveTab(tab);
    };
    return (

        <Card className="shadow">
            <CardHeader className="p-2 p-b-0 bg-primary">
                <label className="labelUpdateEdit">HOJA DE TRABAJO</label> <br />
                <label className="labelExamNameSimple txt-secondary"></label> <br />
            </CardHeader>

            <div className="d-flex">
                <Nav className="flex-column nav-pills border-tab nav-left" style={{ minWidth: '200px' }}>
                    <NavItem>
                        <NavLink
                            href="#"
                            className={activeTab === '1' ? 'active p-b-0' : 'p-b-0'}
                            onClick={() => changeTabGeneral('1')}
                        >
                            <i className="icofont icofont-ui-edit"></i>
                            <label className="labelMenuItem">Procesos</label>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            href="#"
                            className={activeTab === '2' ? 'active p-b-0' : 'p-b-0'}
                            onClick={() => changeTabGeneral('2')}
                        >
                            <i className="icofont icofont-ui-edit"></i>
                            <label className="labelMenuItem">Elementos</label>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            href="#"
                            className={activeTab === '3' ? 'active p-b-0' : 'p-b-0'}
                            onClick={() => changeTabGeneral('3')}
                        >
                            <i className="icofont icofont-ui-edit"></i>
                            <label className="labelMenuItem">Diluciones</label>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            href="#"
                            onClick={() => history.goBack()}
                        >
                            <i className="icofont icofont-arrow-left"></i>
                            <label className="labelMenuItem">Regresar</label>
                        </NavLink>
                    </NavItem>
                </Nav>
                <CardBody className="flex-fill">
                    {activeTab === '1' && (

                        <Card>
                            <CardBody className="p-1">
                                <div className='ribbon ribbon-clip ribbon-primary'>
                                    {"Lista de Procesos"}
                                </div>
                                <div className="text-right" style={{ margin: 5, paddingBottom: 10 }}>
                                    <Button className="btn btn-pill btn-air-success" color="secondary" size="sm" onClick={handleCreate} ><span className="fa fa-plus-circle"></span></Button>
                                </div>
                                <div className="row">
                                    <div className="offset-8 col-4 pt-1 pb-2">
                                        <Input placeholder='Búsqueda...' className='form-control' onChange={handleSearchWSS} />
                                    </div>
                                </div>
                                {
                                     catwsprocess.length === 0 ?
                                     <div style={{ textAlign: "-webkit-center" }}>
                                         <img className='img-fluid' src={require("../../../assets/images/loginHelenLabs/Alerts/Alert.svg")} style={{ width: "25%" }} alt="" /> <br />
                                         <br />
                                         <p className='f-18'>{"No se ha registrado Procesos"}</p>
                                     </div>
                                        :

                                        <div className="table-responsive">
                                            <TableStriped
                                                notMaped={["visibleTable", "id_exam", "idwsconfig", "comment_dilutions_colonies", "is_lm", "is_ec","tubes"]}
                                                methodsActions={true}
                                                cabeceras={["Nombre", "Orden", "Determinación"]}
                                                items={catwsprocess}
                                                {...{ handleUpdate, handleDelete }}
                                                nextPage={nextPage}
                                                previousPage={previousPage}
                                                totalPageCount={totalPageCount}
                                                currentPage={currentPage}
                                                goToPage={goToPage}
                                            />
                                        </div>
                                }
                            </CardBody>
                        </Card>

                    )}

                    {activeTab === '2' && (
                        <Card>
                            <CardBody className="p-1">
                                <div className='ribbon ribbon-clip ribbon-primary'>
                                    {"Lista de Elementos"}
                                </div>
                                <div className="text-right" style={{ margin: 5, paddingBottom: 10 }}>
                                    <Button className="btn btn-pill btn-air-success" color="secondary" size="sm" onClick={handleCreateElements} ><span className="fa fa-plus-circle"></span></Button>
                                </div>
                                <div className="row">
                                    <div className="offset-8 col-4 pt-1 pb-2">
                                        <Input placeholder='Búsqueda...' className='form-control' onChange={handleSearchWSSElements} />
                                    </div>
                                </div>
                                {
                                    catwselement.length === 0 ?
                                        <div style={{ textAlign: "-webkit-center" }}>
                                            <img className='img-fluid' src={require("../../../assets/images/loginHelenLabs/Alerts/Alert.svg")} style={{ width: "25%" }} alt="" /> <br />
                                            <br />
                                            <p className='f-18'>{"No se ha registrado Elementos"}</p>
                                        </div>
                                        :

                                        <div className="table-responsive">
                                            <TableStriped
                                                notMaped={["visibleTable", "comment", "id_process_config", "id_type_element", "is_result",]}
                                                methodsActions={true}
                                                cabeceras={["Nombre", "Proceso", "Tipo de Valor"]}
                                                items={catwselement}
                                                methodsAbsolutes={
                                                    [
                                                        {
                                                            type: "linkId",
                                                            method: handleUpdateElements,
                                                            icon: "fa fa-edit",
                                                            backgroundColor: "#70cbe8",
                                                            color: "#fff",
                                                            name: "modificarelemento",
                                                            tooltip: "Modificar"
                                                        },
                                                        {
                                                            type: "linkId",
                                                            method: handleDeleteElements,
                                                            icon: "fa fa-trash",
                                                            backgroundColor: "#dc3545",
                                                            color: "#fff",
                                                            name: "eliminarelemento",
                                                            tooltip: "Eliminar"
                                                        }
            
                                                    ]
                                                }
                                                nextPage={nextPage}
                                                previousPage={previousPage}
                                                totalPageCount={totalPageCount}
                                                currentPage={currentPage}
                                                goToPage={goToPage}
                                            />
                                        </div>
                                }
                            </CardBody>
                        </Card>
                    )}
                    {activeTab === '3' && (
                         <Card>
                         <CardBody className="p-1">
                             <div className='ribbon ribbon-clip ribbon-primary'>
                                 {"Lista de Diluciones"}
                             </div>
                             <div className="text-right" style={{ margin: 5, paddingBottom: 10 }}>
                                 <Button className="btn btn-pill btn-air-success" color="secondary" size="sm" onClick={handleCreateDilutions} ><span className="fa fa-plus-circle"></span></Button>
                             </div>
                             <div className="row">
                                 <div className="offset-8 col-4 pt-1 pb-2">
                                     <Input placeholder='Búsqueda...' className='form-control' onChange={handleSearchWSSDilutions} />
                                 </div>
                             </div>
                             {
                                 catwsdilutions.length === 0 ?
                                     <div style={{ textAlign: "-webkit-center" }}>
                                         <img className='img-fluid' src={require("../../../assets/images/loginHelenLabs/Alerts/Alert.svg")} style={{ width: "25%" }} alt="" /> <br />
                                         <br />
                                         <p className='f-18'>{"No se han registrado Colonias"}</p>
                                     </div>
                                     :
                                     <div className="table-responsive">
                                         <TableStriped
                                             notMaped={["visibleTable", "id_process_config"]}
                                             methodsActions={true}
                                             cabeceras={["Nombre", "Proceso", "Tubos"]}
                                             items={catwsdilutions}
                                             methodsAbsolutes={
                                                 [
                                                     {
                                                         type: "linkId",
                                                         method: handleUpdateDilutions,
                                                         icon: "fa fa-edit",
                                                         backgroundColor: "#70cbe8",
                                                         color: "#fff",
                                                         name: "modificarelemento",
                                                         tooltip: "Modificar"
                                                     },
                                                     {
                                                         type: "linkId",
                                                         method: handleDeleteDilutions,
                                                         icon: "fa fa-trash",
                                                         backgroundColor: "#dc3545",
                                                         color: "#fff",
                                                         name: "eliminarelemento",
                                                         tooltip: "Eliminar"
                                                     }
         
                                                 ]
                                             }
                                             nextPage={nextPage}
                                             previousPage={previousPage}
                                             totalPageCount={totalPageCount}
                                             currentPage={currentPage}
                                             goToPage={goToPage}
                                         />
                                     </div>
                             }
                         </CardBody>
                     </Card>
                    )}
                </CardBody>
            </div>
            <ModalCreateUWSProcess
                {
                ...{
                    catwsprocess, id_exam, idwsconfig, order_element, name, comment_dilutions_colonies, is_lm, is_ec, datadeterminations, validaciones,
                    method,
                    handleInputChange, handleSearchWSS, loading,
                    toggle, modal, modalTitle,
                    saveCreate, saveUpdate, saveDelete,
                    nextPage, previousPage, goToPage, totalPageCount, currentPage,
                    handleUpdateValues, handleSelectValues, formValues, handleSelectValuesNew,

                    //elementos
                    catwselement, id_elements_config, dataDatacatwselementSearch,
                    handleSearchWSSElements, handleUpdateElements, saveUpdateElements, handleDeleteElements,
                    saveDeleteElements, validarFormElements, handleCreateElements, saveCreateElements,
                    formValuesElements, handleInputChangeElements, handleUpdateValuesElements, handleSelectValuesElements, validacionesElements,

                    //diluciones
                    handleSearchWSSDilutions,handleUpdateDilutions,saveUpdateDilutions,handleDeleteDilutions,
                    saveDeleteDilutions,validarFormDilutions,handleCreateDilutions,saveCreateDilutions,
                    formValuesDilutions, handleInputChangeDilutions, handleUpdateValuesDilutions, handleSelectValuesDilutions,
                    validacionesDilutions,

                }
                }
            />


        </Card>
    );

};
